import React from "react";
import { COLORS, FONTS } from "./constants";

/* ── Background: deep 3D parallax starfield + drifting orbs ── */
export const Backdrop: React.FC<{ frame: number; accent: string }> = ({ frame, accent }) => {
  const drift = Math.sin(frame * 0.005) * 8;
  const driftX = Math.cos(frame * 0.004) * 5;
  return (
    <>
      {/* Deep-layer radial haze */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: `radial-gradient(ellipse 80% 60% at 50% 40%, ${accent}10 0%, transparent 70%)`,
          pointerEvents: "none",
        }}
      />
      {/* Grid lines */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `linear-gradient(${accent}0a 1px, transparent 1px), linear-gradient(90deg, ${accent}0a 1px, transparent 1px)`,
          backgroundSize: "80px 80px",
          transform: `translate(${driftX}px, ${drift}px)`,
          pointerEvents: "none",
        }}
      />
      {/* Far parallax orbs */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          transform: `translateY(${Math.sin(frame * 0.008) * 12}px) translateX(${Math.cos(frame * 0.006) * 8}px)`,
          pointerEvents: "none",
        }}
      >
        {[
          { x: 200, y: 240, s: 520, c: accent, sp: 0.005, ph: 0 },
          { x: 1680, y: 340, s: 460, c: COLORS.neonPurple, sp: 0.004, ph: 2 },
          { x: 960, y: 880, s: 620, c: COLORS.neonBlue, sp: 0.003, ph: 4 },
          { x: 480, y: 800, s: 340, c: COLORS.neonPink, sp: 0.0035, ph: 1.2 },
          { x: 1520, y: 760, s: 380, c: COLORS.neonCyan, sp: 0.0045, ph: 3.1 },
        ].map((o, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              left: o.x + Math.sin(frame * o.sp + o.ph) * 40 - o.s / 2,
              top: o.y + Math.cos(frame * o.sp * 0.7 + o.ph) * 28 - o.s / 2,
              width: o.s,
              height: o.s,
              borderRadius: "50%",
              background: `radial-gradient(circle, ${o.c}0a 0%, transparent 70%)`,
            }}
          />
        ))}
      </div>
      {/* Floating particles */}
      {[...Array(14)].map((_, i) => {
        const px = 100 + ((i * 157) % 1800);
        const py = 80 + ((i * 97) % 920);
        const colors = [COLORS.neonPink, COLORS.neonBlue, COLORS.neonGreen, COLORS.neonOrange, COLORS.neonPurple, COLORS.neonCyan, COLORS.neonYellow];
        const c = colors[i % colors.length];
        const sz = 3 + (i % 4);
        return (
          <div
            key={`p-${i}`}
            style={{
              position: "absolute",
              left: px + Math.sin(frame * 0.02 + i * 1.3) * 22,
              top: py + Math.cos(frame * 0.015 + i * 1.7) * 18,
              width: sz,
              height: sz,
              borderRadius: "50%",
              background: c,
              boxShadow: `0 0 ${sz * 3}px ${c}cc, 0 0 ${sz * 6}px ${c}55`,
              opacity: 0.55 + Math.sin(frame * 0.03 + i) * 0.25,
              pointerEvents: "none",
            }}
          />
        );
      })}
    </>
  );
};

/* ── Scene title — big, glowing, centered-top ── */
export const SceneTitle: React.FC<{
  text: string;
  subtitle?: string;
  color: string;
  frame: number;
  appear: number; // 0..1 from spring
}> = ({ text, subtitle, color, frame, appear }) => (
  <div
    style={{
      position: "absolute",
      top: 70,
      left: 0,
      right: 0,
      textAlign: "center",
      opacity: appear,
      transform: `translateY(${(1 - appear) * -30}px)`,
    }}
  >
    <div
      style={{
        fontSize: 68,
        fontFamily: FONTS.heading,
        fontWeight: 900,
        color,
        textShadow: `0 0 40px ${color}cc, 0 0 80px ${color}55`,
        letterSpacing: -1.5,
      }}
    >
      {text}
    </div>
    {subtitle && (
      <div
        style={{
          fontSize: 28,
          fontFamily: FONTS.body,
          fontWeight: 500,
          color: COLORS.textSecondary,
          marginTop: 12,
          letterSpacing: 1,
          opacity: Math.max(0, (appear - 0.3) / 0.7),
        }}
      >
        {subtitle}
      </div>
    )}
  </div>
);

export function glow(c: string, strong = false): string {
  return strong
    ? `0 0 24px ${c}cc, 0 0 60px ${c}77, 0 0 120px ${c}33`
    : `0 0 16px ${c}99, 0 0 40px ${c}44`;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
